<template>
  <component :is="link ? 'a' : 'div'" v-bind="cardAttrs" :class="classes">
    <div class="summary-card__text">
      <m4-heading level="2" class="summary-card__text__title">{{ title }}</m4-heading>
      <div class="summary-card__text__value">{{ value }}</div>
    </div>
    <div class="summary-card__icon" v-if="icon">
      <m4-icon :icon="icon" class="btn__icon btn__icon--left"></m4-icon>
    </div>
  </component>
</template>

<script>
export default {
  name: "M4SummaryCard",
  props: {
    title: String,
    value: String,
    icon: String,
    variant: String,
    link: String
  },
  computed: {
    classes() {
      let classes = ["summary-card"];
      if (this.variant) {
        classes.push("summary-card--" + this.variant);
      }
      if (this.link) {
        classes.push("summary-card--link");
      }
      return classes;
    },
    cardAttrs() {
      let attrs = {};
      if (this.link) {
        attrs["href"] = this.link;
      }
      return attrs;
    }
  }
};
</script>
